import {useMemo} from 'react';
import {QueryClient, useQuery} from '@tanstack/react-query';
import {
  ParsedDataGS,
  getSuggestionAPI,
} from '@services/new/common/getSuggestions';

// Query key generator
const getSuggestionQueryKey = (type: string, destination?: string) => [
  'suggestions',
  type,
  destination,
];

// Prefetch Suggestions
export const prefetchSuggestion = async (
  queryClient: QueryClient,
  type: string,
  destination?: string
) => {
  const response = getSuggestionAPI(type, destination).send();
  await queryClient.prefetchQuery({
    queryKey: getSuggestionQueryKey(type, destination),
    queryFn: async () => response,
  });
  return response;
};

// Use Suggestions Hook
const useSuggestion = (type: string, destination?: string) => {
  const queryFn = useMemo(() => {
    const apiService = getSuggestionAPI(type, destination);
    return () => apiService.send();
  }, [type, destination]);
  const queryKey = useMemo(
    () => getSuggestionQueryKey(type, destination),
    [type, destination]
  );

  return useQuery<ParsedDataGS>({
    queryKey,
    queryFn,
    staleTime: Infinity, // Keeps data always fresh
    placeholderData: (previousData) => previousData,
  });
};

export default useSuggestion;
